export const calculatePercentOff = ({ reducedAmount, originalAmount }) => {
    const percentage = reducedAmount / originalAmount * 100;
    return Math.floor(100 - percentage) / 100;
};
